module.exports = __webpack_public_path__ + "img/coupon_100.98d088c8.png";